
export enum PickupMethod
{
    Unset = "unset",
    Package = "package",
    Personal = "personal"
}
